import * as React from "react";
const defaultConsent = {
  consent: {
    necessary: false,
    preferences: false,
    statistics: false,
    marketing: false
  },
  enabled: false,
  hasConsent(needsConsent) {
    return !this.enabled || needsConsent.filter((c) => !this.consent[c]).length === 0;
  },
  getDescription: () => ""
};
const CookieConsentContext = React.createContext(defaultConsent);
const CookieConsentProvider = ({
  consent: propConsent = defaultConsent.consent,
  enabled: propEnabled = defaultConsent.enabled,
  content,
  children
}) => {
  const consent = React.useMemo(
    () => ({
      ...defaultConsent.consent,
      ...propConsent
    }),
    [propConsent]
  );
  const contextValue = React.useMemo(
    () => ({
      ...defaultConsent,
      consent,
      enabled: propEnabled,
      content,
      getDescription: (needsConsent) => {
        if (!content) {
          return "";
        }
        const missingConsents = needsConsent.filter((c) => !consent[c]).map((c) => content.categories[c]).join(", ");
        return content.description + " " + missingConsents;
      }
    }),
    [consent, content, propEnabled]
  );
  return /* @__PURE__ */ React.createElement(CookieConsentContext.Provider, { value: contextValue }, children);
};
export {
  CookieConsentContext,
  CookieConsentProvider
};
